var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        fill: "#EABF54",
        height: "16",
        viewBox: "0 0 20 16",
        width: "20",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("g", { attrs: { "fill-rule": "nonzero" } }, [
        _c("path", {
          attrs: {
            d: "M12.017 11.612c1.231-.555 2.203-1.31 2.915-2.266C15.644 8.39 16 7.349 16 6.223c0-1.127-.356-2.168-1.068-3.124-.712-.956-1.684-1.711-2.915-2.267C10.787.277 9.447 0 8 0 6.553 0 5.214.278 3.983.833c-1.231.555-2.203 1.31-2.915 2.266C.356 4.055 0 5.096 0 6.223c0 .964.27 1.871.807 2.722.538.85 1.277 1.568 2.216 2.151a6.889 6.889 0 0 1-.233.535c-.08.162-.174.318-.284.468l-.256.352c-.06.085-.159.205-.295.359a8.296 8.296 0 0 0-.262.303c0-.008-.015.01-.045.055s-.048.065-.051.061c-.004-.004-.02.016-.046.06l-.04.067-.028.061a.267.267 0 0 0-.023.073.508.508 0 0 0-.006.079c0 .028.004.054.012.079.015.105.059.19.13.255.073.065.15.097.234.097h.034c.378-.057.704-.121.977-.194A9.285 9.285 0 0 0 6 12.25c.68.13 1.348.194 1.999.194 1.447 0 2.786-.276 4.017-.832zM5.175 10.14l-.496.38c-.21.156-.444.316-.7.48l.395-1.032L3.28 9.28c-.723-.458-1.283-.999-1.682-1.621C1.2 7.036 1 6.389 1 5.718c0-.836.295-1.618.886-2.347.59-.729 1.386-1.306 2.387-1.732C5.273 1.213 6.349 1 7.5 1c1.151 0 2.227.213 3.227.639 1 .426 1.797 1.003 2.387 1.732.59.729.886 1.511.886 2.347 0 .835-.295 1.617-.886 2.346-.59.729-1.386 1.306-2.387 1.732-1 .426-2.076.639-3.227.639-.564 0-1.14-.058-1.727-.172l-.598-.123z",
          },
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M19.155 11.242c.563-.798.845-1.655.845-2.57 0-.94-.298-1.818-.893-2.634C18.512 5.22 17.702 4.542 16.68 4a5.7 5.7 0 0 1-.524 4.648c-.532.916-1.294 1.725-2.286 2.427-.92.642-1.968 1.134-3.143 1.477-1.174.344-2.4.516-3.678.516-.238 0-.588-.016-1.048-.046 1.595 1.007 3.468 1.511 5.619 1.511.683 0 1.38-.061 2.095-.183.984.672 2.088 1.16 3.31 1.465.286.07.627.13 1.024.184a.369.369 0 0 0 .262-.08.421.421 0 0 0 .154-.252c-.003-.046 0-.071.012-.075.012-.003.01-.028-.006-.074a11.616 11.616 0 0 0-.023-.069l-.03-.057a.546.546 0 0 0-.09-.12 1.47 1.47 0 0 1-.053-.057 8.107 8.107 0 0 0-.321-.338 4.59 4.59 0 0 1-.31-.337c-.063-.08-.152-.191-.267-.332a2.886 2.886 0 0 1-.298-.441 6.198 6.198 0 0 1-.244-.504c.984-.55 1.758-1.223 2.32-2.021z",
          },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }